import { render, staticRenderFns } from "./VOverview.vue?vue&type=template&id=5cbf0bcf&"
import script from "./VOverview.vue?vue&type=script&lang=js&"
export * from "./VOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports